import { style } from "@vanilla-extract/css";
import { formRowGroupStyle } from "../../FormRow/FormRowGroup.css";

export const fieldStyle = style({
  width: "100%",
  selectors: {
    [`${formRowGroupStyle} &`]: {
      maxWidth: "100% !important",
    },
  },
});
